import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
    selector: 'app-analysis-activity-log.component',
    templateUrl: './analysis-activity-log.component.html'
})
export class AnalysisActivityLogComponent implements OnInit {
    @Input() data: any;
    

    constructor(    private drawerService: NzDrawerService){}
    

    async ngOnInit() {
       
    }

    close(): void {
    }

    resetForm(): void { }
}
